import React from 'react';
import { Routes, Route, Link, useLocation, Navigate } from 'react-router-dom';
import styles from './ScheduleArea.module.css';
import ScheduleEditor from './ScheduleEditor';
import FileList from './FileList';

const ScheduleArea = () => {
  const location = useLocation();
  const pathname = location.pathname;
  
  // Determine active tab from URL - check for exact matches or at end of path
  const isWeeklyActive = pathname.endsWith('/schedule/weekly') || pathname.endsWith('/schedule') || pathname.endsWith('/schedule/');
  const isDatedActive = pathname.endsWith('/schedule/dated');
  const isAdditionalActive = pathname.endsWith('/schedule/additional');
  const isBackupsActive = pathname.endsWith('/schedule/backups');
  const isPrintActive = pathname.endsWith('/schedule/print');
  const isFilesActive = pathname.endsWith('/schedule/files');

  return (
    <div className={styles.scheduleArea}>
      <h1>Schedule Editor</h1>
      
      <div className={styles.tabs}>
        <Link 
          to="/admin/schedule/weekly" 
          className={`${styles.tab} ${isWeeklyActive ? styles.active : ''}`}
        >
          Weekly Schedules
        </Link>
        <Link 
          to="/admin/schedule/dated" 
          className={`${styles.tab} ${isDatedActive ? styles.active : ''}`}
        >
          Dated Schedules
        </Link>
        <Link 
          to="/admin/schedule/additional" 
          className={`${styles.tab} ${isAdditionalActive ? styles.active : ''}`}
        >
          Additional Info
        </Link>
        <Link 
          to="/admin/schedule/backups" 
          className={`${styles.tab} ${isBackupsActive ? styles.active : ''}`}
        >
          Backups
        </Link>
        <Link 
          to="/admin/schedule/print" 
          className={`${styles.tab} ${isPrintActive ? styles.active : ''}`}
        >
          Print
        </Link>
        <Link 
          to="/admin/schedule/files" 
          className={`${styles.tab} ${isFilesActive ? styles.active : ''}`}
        >
          Files
        </Link>
      </div>

      <div className={styles.tabContent}>
        <Routes>
          <Route path="weekly" element={<ScheduleEditor activeTab="weekly" />} />
          <Route path="dated" element={<ScheduleEditor activeTab="dated" />} />
          <Route path="additional" element={<ScheduleEditor activeTab="additional" />} />
          <Route path="backups" element={<ScheduleEditor activeTab="backups" />} />
          <Route path="print" element={<ScheduleEditor activeTab="print" />} />
          <Route path="files" element={<FileList />} />
          <Route path="" element={<Navigate to="weekly" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default ScheduleArea;

